import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Lock, LogIn } from "lucide-react";
import { toast } from "sonner";
import { Input } from "../components/ui/input";
import { BuddhaLogo } from "../components/BuddhaLogo";
import { api, formatApiErrorDetail } from "../lib/api";
import { useAuth } from "../context/AuthContext";

const AdminLoginPage = () => {
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const { login } = useAuth();
  const navigate = useNavigate();

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const { data } = await api.post("/admin/login", { password });
      login(data.token);
      toast.success("Welcome back, Admin!");
      navigate("/admin/dashboard");
    } catch (err) {
      toast.error(formatApiErrorDetail(err.response?.data?.detail) || "Login failed");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-[#0F2942] flex items-center justify-center p-4">
      <div className="w-full max-w-md">
        <div className="text-center mb-8">
          <div className="flex justify-center mb-4">
            <BuddhaLogo className="h-16 w-16" />
          </div>
          <h1 className="font-display text-2xl font-bold text-white">Admin Portal</h1>
          <p className="text-slate-400 text-sm mt-1">Lord Buddha Awareness And Development Foundation</p>
        </div>
        <form onSubmit={submit} className="bg-white rounded-2xl p-7 shadow-2xl">
          <label className="flex items-center gap-2 text-sm font-semibold text-slate-700 mb-2">
            <Lock className="h-4 w-4 text-emerald-600" /> Enter Admin Password
          </label>
          <Input
            type="password"
            required
            autoFocus
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            placeholder="••••••••"
            data-testid="admin-login-password-input"
          />
          <button
            type="submit"
            disabled={loading}
            data-testid="admin-login-submit-btn"
            className="mt-5 w-full inline-flex items-center justify-center gap-2 bg-emerald-600 hover:bg-emerald-700 disabled:opacity-60 text-white font-semibold py-3 rounded-full transition-all"
          >
            <LogIn className="h-4 w-4" /> {loading ? "Verifying..." : "Login"}
          </button>
        </form>
        <p className="text-center text-slate-500 text-xs mt-6">Authorized personnel only.</p>
      </div>
    </div>
  );
};

export default AdminLoginPage;
